import { useEffect, useState } from "react";
import { useGetBusinessUnits } from "../../api/v1";
import { SelectOption } from "../../types/select";

type UseBusinessUnitOptions = {
  isEnabled?: boolean;
};

export const useBusinessUnitOptions = (options: UseBusinessUnitOptions = {}) => {
  
  const { isEnabled } = options;
  const [businessUnitOptions, setBusinessUnitOptions] = useState<SelectOption[]>([]);

  const { businessUnits, isLoadingBusinessUnits } = useGetBusinessUnits({ isEnabled });

  useEffect(() => {
    if (!isEnabled) return;

    const options = businessUnits.map((item) => ({
      label: item.businessUnitName,
      value: item.businessUnitId,
    }));

    setBusinessUnitOptions(options);
  }, [isEnabled, businessUnits]);

  return { businessUnitOptions, isLoadingBusinessUnits };
};
